import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertLabeledGraphicToServerModel = (widget) => {
    var _a, _b, _c, _d;
    const ids = [];
    const assetIds = [];
    const titles = [];
    const texts = [];
    const x = [];
    const y = [];
    const markerIcons = [];
    // main graphic
    ids.push(null);
    assetIds.push(widget.value.data.assetId);
    titles.push(null);
    texts.push(null);
    x.push(null);
    y.push(null);
    markerIcons.push(null);
    for (const value of widget.value.data.markers) {
        ids.push(value.id);
        assetIds.push((_a = value.assetId) !== null && _a !== void 0 ? _a : null);
        titles.push((_b = value.title) !== null && _b !== void 0 ? _b : null);
        texts.push((_c = value.description) !== null && _c !== void 0 ? _c : null);
        x.push(value.x);
        y.push(value.y);
        markerIcons.push((_d = value.markerIcon) !== null && _d !== void 0 ? _d : null);
    }
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.labeledGraphic,
        data: {
            ids,
            assets: assetIds,
            texts,
            titles,
            x,
            y,
            markerIcons,
        },
        properties: {
            displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
            isRequired: widget.value.properties.isRequired,
        },
    };
};
export const convertLabeledGraphicFromServerModel = (serverModel) => {
    var _a, _b, _c, _d, _e;
    const dataKeys = ['ids', 'assets', 'titles', 'texts', 'x', 'y', 'markerIcons'];
    const dataLengths = dataKeys.map((key) => serverModel.data[key].length);
    const markerCount = Math.max(...dataLengths);
    const areAllTheSame = dataLengths.every((length) => length === dataLengths[0]);
    if (!areAllTheSame) {
        console.warn('Widget has incorrect lengths of slide data arrays');
    }
    const backgroundGraphicAssetId = serverModel.data.assets[0];
    if (backgroundGraphicAssetId === null) {
        throw new Error('Main asset is required');
    }
    if (!(serverModel.data.x[0] === null && serverModel.data.y[0] === null)) {
        throw new Error('Main asset should not have x and y');
    }
    const markers = [];
    for (let i = 1; i < markerCount; i++) {
        const id = serverModel.data.ids[i];
        const x = serverModel.data.x[i];
        const y = serverModel.data.y[i];
        if (id === null || x === null || y === null) {
            throw new Error('Hotspot id, x, and y are required');
        }
        const marker = {
            id: id,
            x: x,
            y: y,
            title: (_a = serverModel.data.titles[i]) !== null && _a !== void 0 ? _a : undefined,
            description: (_b = serverModel.data.texts[i]) !== null && _b !== void 0 ? _b : undefined,
            assetId: (_c = serverModel.data.assets[i]) !== null && _c !== void 0 ? _c : undefined,
            markerIcon: (_d = serverModel.data.markerIcons[i]) !== null && _d !== void 0 ? _d : undefined,
        };
        markers.push(marker);
    }
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.labeledGraphic,
            data: {
                assetId: backgroundGraphicAssetId,
                markers: markers,
            },
            properties: {
                isRequired: (_e = serverModel.properties.isRequired) !== null && _e !== void 0 ? _e : false,
                displayDelayInSeconds: serverModel.properties.displayDelayInSeconds,
            },
        },
    };
};
